export const GOOGLE_ANALYTICS_ACCOUNT = 'G-NSEKRQF5TF';
export const SUPPORT_URL = 'https://support.bumble.com/hc';
const CONTACT_US_URL = 'https://support.bumble.com/hc/[lang]/requests/new';

export function getContactUsUrl(lang: string) {
    return CONTACT_US_URL.replace('[lang]', lang);
}
